import { API } from "config";
import request from "utilities/request";

import type { ChatRecordJson } from "../types/ChatRecordJson";

const baseUrl = API.metricsApi.url;

export async function postChatRecord(
  body: ChatRecordJson,
  getAccessToken: () => Promise<string>
) {
  // Do nothing if baseUrl is null. This makes it easy to disable metrics
  // requests when running locally.
  if (baseUrl === null) return;

  const accessToken = await getAccessToken();
  const url = `${baseUrl}/analytics/chat-record`;
  const method = "POST";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = { method, headers, body: JSON.stringify(body) };

  const response = await request(url, options);
  const responseJson = await response.json();
  return responseJson;
}
